import React from 'react';
import styled from 'styled-components';
import { PrimaryButton } from '../../styles/components';
import heroImage from '../../assets/hero.jpg';

const HeroContainer = styled.section`
  position: relative;
  height: 100vh;
  min-height: 700px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 0;
  overflow: hidden;
  
  @media (max-width: 768px) {
    min-height: 600px;
  }
`;

const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${heroImage});
  background-size: cover;
  background-position: center;
`;

const TopGradientOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 25%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.5) 60%, rgba(0, 0, 0, 0) 100%);
  z-index: 1;
`;

const BottomGradientOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.5) 60%, rgba(0, 0, 0, 0) 100%);
  z-index: 1;
`;

const TopContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: var(--container-width);
  margin: 0 auto;
  padding: calc(var(--spacing-xl) * 2) var(--spacing-md) 0 var(--spacing-md);
  width: 100%;
  display: flex;
  justify-content: center;
`;

const BottomContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: var(--container-width);
  margin: 0 auto;
  padding: 0 var(--spacing-md) var(--spacing-xl) var(--spacing-md);
  width: 100%;
  display: flex;
  justify-content: center;
  
  @media (max-width: 768px) {
    position: absolute;
    bottom: var(--spacing-md);
    left: 0;
    right: 0;
  }
`;

const TitleContainer = styled.div`
  max-width: 600px;
  padding-top: var(--spacing-xl);
  text-align: center;
  
  @media (max-width: 768px) {
    max-width: 100%;
    padding-top: var(--spacing-lg);
  }
`;

const DescriptionContainer = styled.div`
  max-width: 600px;
  padding-bottom: var(--spacing-lg);
  text-align: center;
  
  @media (max-width: 768px) {
    max-width: 100%;
    padding-bottom: 0;
  }
`;

const HeroHeading = styled.h1`
  font-size: 3.5rem;
  line-height: 1.1;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  
  span {
    color: var(--accent-2);
  }
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const HeroSubheading = styled.p`
  font-size: 1.25rem;
  margin-bottom: var(--spacing-lg);
  max-width: 500px;
  line-height: 1.6;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    margin: 0 auto var(--spacing-md) auto;
  }
`;

const HeroButtonContainer = styled.div`
  display: flex;
  gap: var(--spacing-md);
  justify-content: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: var(--spacing-sm);
  }
`;

const Hero: React.FC = () => {
  return (
    <HeroContainer id="home">
      <BackgroundImage />
      <TopGradientOverlay />
      <BottomGradientOverlay />

      <TopContent>
        <TitleContainer>
          <HeroHeading>
            European & Japanese <span>Auto Specialists</span>
          </HeroHeading>
        </TitleContainer>
      </TopContent>

      <BottomContent>
        <DescriptionContainer>
          <HeroSubheading>
            Factory-trained technicians specializing in European and Japanese vehicles,
            delivering precision engineering and exceptional service in San Francisco.
          </HeroSubheading>
          <HeroButtonContainer>
            <PrimaryButton as="a" href="#services">
              Explore Our Services
            </PrimaryButton>
            <PrimaryButton as="a" href="#contact" style={{ backgroundColor: 'transparent', border: '1px solid white', color: 'white' }}>
              Contact Us
            </PrimaryButton>
          </HeroButtonContainer>
        </DescriptionContainer>
      </BottomContent>
    </HeroContainer>
  );
};

export default Hero; 